import { MessageDescriptor } from 'react-intl';

import { IGiftActions, EGiftType } from '../../../model';
import { messages } from '../messages';

export const getActionListTitle = (): ((item: IGiftActions) => MessageDescriptor | null) => {
  let chooseOne = 0;
  let chooseMore = 0;
  let chooseOneSample = 0;
  let chooseMoreSample = 0;

  const getGiftActionTitle = (item: IGiftActions): MessageDescriptor | null => {
    switch (item.giftType) {
      case EGiftType.SAMPLE: {
        if (item.choose === 1) {
          const message = chooseOneSample % 2 === 0 ? messages.chooseOneSample : messages.selectOneSample;
          chooseOneSample++;
          return message;
        }
        const message = chooseMoreSample % 2 === 0 ? messages.chooseMoreSample : messages.selectMoreSample;
        chooseMoreSample++;
        return message;
      }

      case EGiftType.SPECIAL:
      case EGiftType.BASIC:
      case EGiftType.GWP: {
        if (item.choose === 1) {
          const message = chooseOne % 2 === 0 ? messages.chooseOne : messages.selectOne;
          chooseOne++;
          return message;
        }
        const message = chooseMore % 2 === 0 ? messages.chooseMore : messages.selectMore;
        chooseMore++;
        return message;
      }
      default:
        return null;
    }
  };

  return getGiftActionTitle;
};
